import type {
  AdsBreakdownRow,
  AdsKind,
  ConnectionTestResult,
  Ga4BreakdownRow,
  Ga4Kind,
  GscBreakdownRow,
  GscKind,
  MarketingOverview,
  MarketingSource,
  MarketingStatus,
  SyncResult,
} from '../domain/marketing'

export interface MarketingRange {
  /** `AAAA-MM-JJ`, inclus. */
  from: string
  to: string
}

/** Lecture des données synchronisées (base locale) et pilotage de la synchronisation. Lecture seule vis-à-vis de Google. */
export interface MarketingRepository {
  getStatus(): Promise<MarketingStatus>
  getOverview(range: MarketingRange): Promise<MarketingOverview>
  getAdsBreakdown(kind: AdsKind, range: MarketingRange): Promise<AdsBreakdownRow[]>
  getGa4Breakdown(kind: Ga4Kind, range: MarketingRange): Promise<Ga4BreakdownRow[]>
  getGscBreakdown(kind: GscKind, range: MarketingRange): Promise<GscBreakdownRow[]>
  /** Synchronisation immédiate; `backfill` reprend l'historique initial. */
  sync(sources?: readonly MarketingSource[], backfill?: boolean): Promise<SyncResult[]>
  testConnections(): Promise<ConnectionTestResult[]>
}

export class MarketingError extends Error {
  constructor(readonly code: string) {
    super(code)
    this.name = 'MarketingError'
  }
}
